import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function normalizeSocialLinks(raw: unknown): { twitter: string; linkedin: string; github: string; website: string } {
  const result = {
    twitter: '',
    linkedin: '',
    github: '',
    website: '',
  };

  if (!raw) return result;

  if (Array.isArray(raw)) {
    raw.forEach((link) => {
      if (typeof link === 'string') {
        const trimmed = link.trim();
        if (trimmed.includes('linkedin.com')) {
          result.linkedin = trimmed;
        } else if (trimmed.includes('twitter.com') || trimmed.includes('x.com')) {
          result.twitter = trimmed;
        } else if (trimmed.includes('github.com')) {
          result.github = trimmed;
        } else if (trimmed.startsWith('http') || trimmed.includes('.')) {
          result.website = trimmed;
        }
      }
    });
  } else if (typeof raw === 'object') {
    const obj = raw as Record<string, unknown>;
    if (typeof obj.linkedin === 'string') result.linkedin = obj.linkedin.trim();
    if (typeof obj.twitter === 'string') result.twitter = obj.twitter.trim();
    if (typeof obj.github === 'string') result.github = obj.github.trim();
    if (typeof obj.website === 'string') result.website = obj.website.trim();
    
    // Fallback for case differences
    if (typeof obj.twitterUrl === 'string') result.twitter = obj.twitterUrl.trim();
    if (typeof obj.linkedinUrl === 'string') result.linkedin = obj.linkedinUrl.trim();
    if (typeof obj.githubUrl === 'string') result.github = obj.githubUrl.trim();
  }

  return result;
}

export interface SchemaAreaServed {
  "@type": "Country" | "Place";
  "name": string;
}

export function getAreaServed(
  jurisdiction: string | null,
  jurisdictionScope?: string | null
): SchemaAreaServed | undefined {
  const rawInput = jurisdictionScope || jurisdiction;
  if (!rawInput) return undefined;

  // Normalize: lowercase, trim, and strip trailing " only"
  let normalized = rawInput.toLowerCase().trim();
  if (normalized.endsWith(' only')) {
    normalized = normalized.slice(0, -5).trim();
  }

  switch (normalized) {
    case 'us':
    case 'us-federal':
      return { "@type": "Country", "name": "United States" };
    case 'uk':
    case 'uk-common-law':
      return { "@type": "Country", "name": "United Kingdom" };
    case 'india':
    case 'india-ecourts':
      return { "@type": "Country", "name": "India" };
    case 'canada':
      return { "@type": "Country", "name": "Canada" };
    case 'australia':
      return { "@type": "Country", "name": "Australia" };
    case 'eu':
      return { "@type": "Place", "name": "European Union" };
    case 'global':
    default:
      return undefined;
  }
}
